import { render } from "./vue-countTo.vue?vue&type=template&id=0581c4b9"
import script from "./vue-countTo.vue?vue&type=script&lang=js"
export * from "./vue-countTo.vue?vue&type=script&lang=js"
script.render = render

export default script